import { useState } from "react";
import { Lock, ArrowRight } from "lucide-react";
import { LogoMark } from "../components/Logo";

export default function ShareGate({ onSubmit, error, loading }) {
  const [password, setPassword] = useState("");

  return (
    <div className="h-[100dvh] bg-white bg-blueprint-light flex items-center justify-center px-6" data-testid="share-gate">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center text-center">
          <LogoMark size={44} />
          <div className="mt-6 inline-flex p-3 rounded-full bg-brand-subtle text-brand">
            <Lock size={20} />
          </div>
          <h1 className="mt-4 font-display font-extrabold tracking-tight text-2xl text-ink">
            Presentazione protetta
          </h1>
          <p className="mt-2 text-sm text-slate-500">
            Inserisci la password per accedere al pitch deck Proaura.
          </p>
        </div>
        <form
          className="mt-8 space-y-3"
          onSubmit={(e) => {
            e.preventDefault();
            if (password.trim()) onSubmit(password.trim());
          }}
        >
          <input
            data-testid="share-password-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            autoFocus
            className="w-full rounded-xl border border-line bg-white px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-brand/30 focus:border-brand"
          />
          {error && (
            <p data-testid="share-gate-error" className="text-sm text-brand">
              {error}
            </p>
          )}
          <button
            data-testid="share-access-button"
            type="submit"
            disabled={loading || !password.trim()}
            className="w-full inline-flex items-center justify-center gap-2 rounded-xl bg-ink hover:bg-graphite text-white font-display font-semibold text-sm px-4 py-3 transition-colors disabled:opacity-40"
          >
            {loading ? "Verifica…" : "Accedi alla presentazione"}
            <ArrowRight size={15} />
          </button>
        </form>
      </div>
    </div>
  );
}
